import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { LOGO } from "../../lib/i18n";
import { HTML_LANG } from "../../lib/blogApi";

export const useHead = ({ title, description, canonical, alternate, lang }) => {
  useEffect(() => {
    document.title = title;
    document.documentElement.lang = HTML_LANG[lang] || "nb";
    const set = (sel, make, attr, val) => {
      let el = document.head.querySelector(sel);
      if (!el) { el = make(); document.head.appendChild(el); }
      el.setAttribute(attr, val);
      return el;
    };
    const link = (rel, extra = "") => () => { const l = document.createElement("link"); l.rel = rel; if (extra) l.type = extra; return l; };
    const made = [];
    if (canonical) set('link[rel="canonical"]', link("canonical"), "href", canonical);
    if (alternate) made.push(set('link[rel="alternate"][type="text/html"]', link("alternate", "text/html"), "href", alternate));
    if (description) set('meta[name="description"]', () => { const m = document.createElement("meta"); m.name = "description"; return m; }, "content", description);
    return () => made.forEach((el) => el.remove());
  }, [title, description, canonical, alternate, lang]);
};

export const BlogLayout = ({ children }) => (
  <div className="blog-root min-h-screen bg-paper text-ink">
    <a href="#main" data-testid="blog-skip-link"
      className="sr-only focus:not-sr-only focus:fixed focus:top-3 focus:left-3 focus:z-50 focus:bg-paper focus:px-4 focus:py-2 focus:border focus:border-ink">
      Hopp til innhold
    </a>
    <header className="border-b border-rule">
      <div className="mx-auto max-w-[1100px] px-5 md:px-8 h-16 flex items-center justify-between gap-4">
        <Link to="/" data-testid="blog-home-link" className="flex items-center gap-3" aria-label="nickolass.com – forsiden">
          <img src={LOGO} alt="" className="h-8 w-auto" />
        </Link>
        <nav aria-label="Blogg" className="flex items-center gap-5 font-mono text-[12px] tracking-[0.14em] uppercase">
          <Link to="/blog" data-testid="blog-nav-index" className="hover:text-[#7a2d00] underline-offset-4 hover:underline">Blogg</Link>
          <a href="/#chat" data-testid="blog-nav-chat" className="hover:text-[#7a2d00] underline-offset-4 hover:underline">Snakk med tvillingen</a>
        </nav>
      </div>
    </header>
    <main id="main" tabIndex={-1} className="outline-none">{children}</main>
    <footer className="border-t border-rule mt-24">
      <div className="mx-auto max-w-[1100px] px-5 md:px-8 py-10 flex flex-wrap gap-x-6 gap-y-2 text-sm text-[#4a4a4a]">
        <span>© Nettpilot AS · Nickolass Jensen</span>
        <a href="/api/blog" className="underline underline-offset-4" data-testid="blog-footer-machine">Maskinlesbar versjon</a>
        <a href="/api/blog/feed.xml" className="underline underline-offset-4">RSS</a>
        <Link to="/personvern" className="underline underline-offset-4">Personvern</Link>
      </div>
    </footer>
  </div>
);
